import * as React from "react";
import react, { useEffect, useState } from "react";
import styled from "styled-components";
import Header from "../components/header/index";
import CotizadorBicicleterias from "../components/bicicleterias/cotizador/index";
import Cubrimos from "../components/home/cubrimos/index";
import Pasos from "../components/home/pasos/index";
import Carousel from "../components/home/carouseles";
import BicisAseguradas from "../components/home/bicisAseguradas/index";
import Comunicacion from "../components/home/comunicacion";
import Beneficios from "../components/home/beneficios/index";
import Questions from "../components/home/preguntasFrecuentes/index";
import SeguroParaTodos from "../components/footer/seguroParaTodo";
import Footer from "../components/footer/index";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);
`;

export default function CotBicicleterias() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [ip, setIp] = useState("");
  const utm_source = searchParams.get("utm_source");
  const utm_medium = searchParams.get("utm_medium");
  const utm_campaign = searchParams.get("utm_campaign");
  const channel = 5;

  useEffect(() => {
    const data = async () => {
      const res = await axios.get("https://geolocation-db.com/json/");
      console.log(res.data);
      setIp(res.data.IPv4);
      console.log(res.data.IPv4);
    };
    data();
  }, []);

  useEffect(() => {
    const getCanales = async () => {
      try {
        if (utm_source && ip) {
          const canales = await axios.get("http://localhost:5000/canales");

          // Buscar ID del canal en base al nombre del UTM
          const selectCanal = canales.data.find((canal) => {
            return canal.descripcion.replace(/\s+/g, "") === utm_source;
          });
          const channelID = selectCanal.numero;
          const channelName = selectCanal.descripcion;
          console.log(channelID);

          /*
          // Buscar nombre en base al ID del canal
          const findChannelName = canales.data.find(canal => {
            return canal.numero === channel
          })
          const channelName = findChannelName.descripcion
          console.log(channelName)
          */
          let today = new Date();

          // POSTEAR DATA EN BASE
          const data = {
            //utm_source: channelName,
            //canal: channelID,
            producto: 1,
            fecha:
              today.getFullYear() +
              "-" +
              (today.getMonth() + 1) +
              "-" +
              today.getDate(),
            hora: today.getHours() + ":" + today.getMinutes(),
            nombre: "Jinx",
            telefono: "1585993388",
            email: "jinx@gmail.com",
            canal: channelID,
            vendedor: 1,
            utm_source: channelName,
            utm_medium: utm_medium ? utm_medium : "",
            utm_campaign: utm_campaign ? utm_campaign : "",
            ip_address: ip,
            estado: 1,
          };

          const postChannels = await axios.post(
            "http://localhost:5000/pruebas",
            data
          );
          console.log(postChannels);
        }
      } catch (error) {
        console.log("Hubo un error", error);
      }
    };
    getCanales();
  }, [ip]);

  return (
    <Container>
      {/* Header */}
      <Header></Header>
      {/* Cotizador Bicicleterias*/}
      <CotizadorBicicleterias></CotizadorBicicleterias>
      {/* Cosas que cubre el seguro */}
      <Cubrimos></Cubrimos>
      {/* Pasos para contratar el seguro */}
      <Pasos></Pasos>
      {/* Carousel con banner */}
      <Carousel></Carousel>
      {/* Bicis que aseguramos */}
      <BicisAseguradas></BicisAseguradas>
      {/* Beneficios del seguro */}
      <Beneficios></Beneficios>
      {/* Comunicacion */}
      <Comunicacion></Comunicacion>
      {/* Preguntas frecuentes */}
      <Questions></Questions>
      {/* Seguros para todos */}
      <SeguroParaTodos></SeguroParaTodos>
      {/* Footer */}
      <Footer></Footer>
    </Container>
  );
}
